import alt from 'alt'
import Immutable from 'immutable'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { CheckBlogActions } from 'actions'
import Enum from 'utils/Enum'

@createStore(alt)
export default class CheckBlogStore {
  constructor() {
    this.state = {
      detectedBlogUrl: '',
      detectedFeedUrl: '',
      detectingBlogUrls: null
    }

    this.bindActions(CheckBlogActions)
  }

  static displayName = 'CheckBlogStore'

  setDetectingBlogUrls(detectingBlogUrls) {
    this.setState({ detectingBlogUrls })
  }

  blogUrlsDetected(data) {
    this.setState({ detectedBlogUrl: data.blogUrl, detectedFeedUrl: data.feedUrl })
  }
}



// WEBPACK FOOTER //
// ./app/stores/CheckBlogStore.js